import { loaders } from 'entities';

import { UserAvatar } from 'components/UserAvatar';

interface RequestedByProps {
  children?: never;
  userId: string;
}

export function InvoiceRequestedBy({ userId }: RequestedByProps): JSX.Element | null {
  const { data: user } = loaders.users.find.use({
    params: { id: userId },
    blockLoad: !userId,
  });

  if (!user) return null;

  return <UserAvatar user={user} size={32} name nameClassName="font-medium" />;
}
